import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { InformationService } from '../../../services/information.service';
import { SharedService } from '../../../services/shared.service';
import { Construction } from '../../../viewmodel'; 
import { Animations } from '../../common/animations';

@Component({
  selector: 'app-construnction',
  templateUrl: './construction.component.html',
  providers: [InformationService],
  animations: [Animations.flyInOut]      
})
export class ConstructionComponent implements OnInit {
    animate: string = 'active';
    title: string = 'Construction Type';
    projectId: number = 0;
    isEdit: boolean = false; 
    pageError: any = [];
    pageSuccess: any = [];
    submitted: boolean = false;
    constForm: FormGroup;
    model: Construction;
    isAppEditable: boolean = false;

    constructor(private router: Router
	, private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private informationService: InformationService
        , private sharedService: SharedService) {

        this.model = new Construction();
        this.model.ProjectId = this.projectId; 
    }
    ngOnInit() {

        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null) {
                this.projectId = ids.projectId;
            }
          
        }
        if (this.projectId <= 0)
            this.sharedService.navigateHome();    

  	this.constForm = this.frmBuilder.group({ 
            NewConstruction: [null],          
            Conversion: [null],
            Enlargement: [null]
     
        });
        this.informationService.getQuestionByType(this.projectId, 'CONST')
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    if (success.Result != null) {
                        this.model = success.Result;
                        this.isEdit = this.model.IsValid;
                    }                      

                    if (this.model.ProjectId == 0 && this.projectId == 0)
                        this.showError("Project ID not found!")
                    else if (this.model.ProjectId == 0)
                        this.model.ProjectId = this.projectId;
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage)
            })
        }

    next(button) {
        
        this.submitted = true;
        if ((this.model.NewConstruction == false || this.model.NewConstruction == null) && (this.model.Conversion == false || this.model.Conversion == null) && (this.model.Enlargement == false || this.model.Enlargement == null))
            return false; 

        //this.model.IsValid = true; 
        this.informationService.SaveConstruction(this.model)
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    if (button == 'NEXT')
                        this.router.navigate(["/information/affordablehousing"]);
                    else if (button = 'LATTER')
                        this.sharedService.navigateSummary();
                    else if (button == 'PRE')
                        this.router.navigate(["/information/housingarea"]);
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage);
            })
    }

    previous() {
        this.router.navigate(["/information/housingarea"]);
    }

    home() {
        this.sharedService.navigateHome();
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    validateConstructionType()
    {
        var res = (((this.constForm.controls['NewConstruction'].value == false || this.constForm.controls['NewConstruction'].value == null) &&
            (this.constForm.controls['Conversion'].value == false || this.constForm.controls['Conversion'].value == null) &&
            (this.constForm.controls['Enlargement'].value == false || this.constForm.controls['Enlargement'].value == null)) && this.submitted);
        return res;
    }
}
